/**
 * SidebarRightIcon - Rechtes Sidebar-Icon für die Titlebar
 *
 * Zeigt ein Panel mit Linien auf der rechten Seite. Ersetzt das Lucide `PanelRight` Icon in der Titlebar.
 *
 * @example
 * ```tsx
 * <SidebarRightIcon />
 * <SidebarRightIcon size={20} />
 * ```
 */
export const SidebarRightIcon = ({ size = 16 }: { size?: number }) => {
  const aspectRatio = 15 / 17
  const height = Math.round(size * aspectRatio)

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1 0.6H2.1C1.27 0.6 0.6 1.27 0.6 2.1V12.1C0.6 12.93 1.27 13.6 2.1 13.6H14.1C14.93 13.6 15.6 12.93 15.6 12.1V2.1C15.6 1.27 14.93 0.6 14.1 0.6Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.6 0.6V13.6"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1 7.1H13.1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1 4.1H13.1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1 10.1H13.1"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
